import * as React from 'react'
import PropTypes from 'prop-types'
import {
    Navbar,
    NavbarBrand,
    NavbarToggler,
    Collapse,
    Container
} from 'reactstrap'
import Navigation from '../Navigation'

import 'react-toastify/dist/ReactToastify.css'
import './App.scss'
import { Outlet } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'

class App extends React.Component {
    static propTypes = {
        routes: PropTypes.array,
        roles: PropTypes.array
    }

    static defaultProps = {
        routes: [],
        roles: []
    }

    state = {
        isNavbarOpen: false
    }

    toggleNavbar = () => {
        this.setState(state => ({
            isNavbarOpen: !state.isNavbarOpen
        }))
    }

    render() {
        const { routes } = this.props

        return (
            <div className="ao-app">
                <ToastContainer
                    position="bottom-right"
                    autoClose={ 5000 }
                    hideProgressBar={ false }
                    newestOnTop={ false }
                    closeOnClick
                    rtl={ false }
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition: Bounce
                />
                <div className="ao-app__header">
                    <Navbar color="primary" dark expand="md" className="ao-app__navigation">
                        <Container>
                            <NavbarBrand href="/">ARO/GIR Administratie</NavbarBrand>
                            <NavbarToggler onClick={ this.toggleNavbar } />
                            <Collapse isOpen={ this.state.isNavbarOpen } navbar>
                                <Navigation routes={ routes } />
                            </Collapse>
                        </Container>
                    </Navbar>
                </div>
                <div id="detail">
                    <Outlet/>
                </div>
            </div>
        )
    }
}

export default App
